import { render, staticRenderFns } from "./AlternativeDeparture.vue?vue&type=template&id=69b73984&"
import script from "./AlternativeDeparture.vue?vue&type=script&lang=ts&"
export * from "./AlternativeDeparture.vue?vue&type=script&lang=ts&"
import style0 from "./AlternativeDeparture.vue?vue&type=style&index=0&id=69b73984&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports